import { Component, Input, Output, OnChanges, EventEmitter, ContentChildren, QueryList, Directive, ViewChildren, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { ColumnSetting, ColumnMap } from './layout.model';

@Component({
    selector: 'base-table-layout',
    templateUrl: './table-layout.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableLayoutComponent implements OnChanges {
    //data
    @Input() records: any[];
    @Input() footer: any;

    //settings
    @Input() settings: ColumnSetting[];
    columnMaps: ColumnMap[];

    //grid params
    @Input() gridActions: any;   
    @Input() hasRowCheckbox: boolean;
    @Input() searched: boolean;
    @Input() loading: boolean;
    @Input() downloading: boolean;
    @Input() count: number;

    //paging
    @Input() pageSize: any;
    @Input() pageNum: any;
    @Input() pageMax: any;

    //sorting
    @Input() sortNum: any;
    @Input() sortDir: any;

    //visuals
    @Input() visuals: any;
    @Input() genericVisuals: any;

    @Output()
    outputMethodHandler: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    changePageHandler: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    changePageSizeHandler: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    changeSortHandler: EventEmitter<any> = new EventEmitter<any>();

    ngOnChanges() {
        if (this.settings) {
            this.columnMaps = this.settings.map(col => new ColumnMap(col));
            if(this.records && this.columnMaps[0]){
                this.records.forEach( record => {
                    let realActionNumber = 0;

                    record.columnMaps = this.copy(this.columnMaps);//Object.assign([], this.columnMaps);
                    
                    if(record.columnMaps[0].actions){
                        (record.columnMaps[0].actions).forEach(action => {
                            action.isHidden = this.renderBoolean(action.hidden,record);
                            if(!action.isHidden){
                                realActionNumber++;
                            }
                            action.isDisabled= this.renderBoolean(action.disabled,record);
                        });
                    }
                    record.actionViewType = realActionNumber;

                });
            }
        } else {
            this.columnMaps = Object.keys(this.records[0]).map(key => {
                return new ColumnMap({ columnKey: key });
            });
        }
    }

    private parentMethodHandle(method: any, params = {}) {
        if (typeof method === "string") {
            params['methodName'] = method;
        }

        this.outputMethodHandler.emit(params);

    }

    private renderBoolean(str: string, params = {}): boolean {
        let ret = eval(str);
        return ret;
    }

    private strToBoolean(str: string): boolean {
        if (str != null && str != '' && (str.toUpperCase() == 'Y' || str.toUpperCase() == 'YES')) {
            return true;
        } else {
            return false;
        }
    }

    protected getSortState(column) {
        return (this.sortNum == column) ? (this.sortDir == 'asc' ? 'sortasc' : 'sortdesc') : 'unsorted';
    }

    private changePage(num: number, type: string): void {
        this.changePageHandler.emit({ 'num': num, 'type': type });
    }

    private changePageSize(num: number): void {
        this.changePageSizeHandler.emit(num);
    }

    private changeSort(num: string): void {
        this.changeSortHandler.emit(num);
    }

    private copy(o) {
        var output, v, key;
        output = Array.isArray(o) ? [] : {};
        for (key in o) {
            v = o[key];
            output[key] = (typeof v === "object" && v !== null) ? this.copy(v) : v;
        }
        return output;
    }  
}